import { render, staticRenderFns } from "./Subtab.vue?vue&type=template&id=76191750&scoped=true&"
import script from "./Subtab.vue?vue&type=script&lang=ts&"
export * from "./Subtab.vue?vue&type=script&lang=ts&"
import style0 from "./Subtab.vue?vue&type=style&index=0&id=76191750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76191750",
  null
  
)

export default component.exports